import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const randomColor = () => {
  let r = Math.floor(Math.random()*255);
  let g = Math.floor(Math.random()*255);
  let b = Math.floor(Math.random()*255);
  return 'rgb(' + r + ',' + g + ',' + b + ')';
};

const createCaptch = (canvas) => {
  let showNum = [];
  let canvasWidth = 130;
  let canvasHeight = 50;
  let context = canvas.getContext('2d');
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  let sCode = 'A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,0,1,2,3,4,5,6,7,8,9';
  let saCode = sCode.split(',');
  let saCodeLen = saCode.length;
  for (let i = 0; i <= 3; i++) {
    let sIndex = Math.floor(Math.random()*saCodeLen);
    let sDeg = (Math.random() * 30 * Math.PI) / 180;
    let cTxt = saCode[sIndex];
    showNum[i] = cTxt;
    let x = 10 + i * 20;
    let y = 20 + Math.random() * 8;
    context.font = 'bold 32px Arial';
    context.translate(x, y);
    context.rotate(sDeg);

    context.fillStyle = randomColor();
    context.fillText(cTxt, 10, 5);

    context.rotate(-sDeg);
    context.translate(-x, -y);
  }
  for (let i = 0; i <= 5; i++) {
    context.strokeStyle = randomColor();
    context.beginPath();
    context.moveTo(
      Math.random() * canvasWidth,
      Math.random() * canvasHeight
    );
    context.lineTo(
      Math.random() * canvasWidth,
      Math.random() * canvasHeight
    );
    context.stroke();
  }
  for (let i = 0; i < 30; i++) {
    context.strokeStyle = randomColor();
    context.beginPath();
    let x = Math.random() * canvasWidth;
    let y = Math.random() * canvasHeight;
    context.moveTo(x, y);
    context.lineTo(x + 1, y + 1);
    context.stroke();
  }
  return showNum.join('');
};

const Captcha = ({ setCaptcha }) => {
  const canvasRef = useRef();
  const [captchaCode, setCaptchCode] = useState('');

  const onChangeCaptcha = () => {
    const newCaptcha = createCaptch(canvasRef.current);
    setCaptchCode(newCaptcha);
  };

  useEffect(() => {
    setCaptcha(captchaCode);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [captchaCode]);

  useEffect(() => {
    const newCaptcha = createCaptch(canvasRef.current);
    setCaptchCode(newCaptcha);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="d-flex align-items-center">
      <canvas id="captcha" ref={canvasRef} height={50} style={{ borderRadius: 4, backgroundColor: '#d1d399' }} />
      <i className="bi bi-arrow-clockwise fs-3 mx-2" onClick={onChangeCaptcha}></i>
    </div>
  );
};

Captcha.defaultProps = {
  setCaptcha: () => {}
};

Captcha.propTypes = {
  setCaptcha: PropTypes.func
};

export default Captcha;